var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal } from 'src/ui/components/modal/Modal';
import { TextInput } from 'src/ui/components/Input/TextInput/TextInput';
import { E_SELECT_SECTION_THEME, SelectSection } from 'src/ui/components/Input/SelectSection/SelectSection';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { getPropsByKeyPath, valueExist } from 'src/shared/helpers/objHelpers';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { COLORS } from 'src/shared/styles/colors';
import styles from './RefusalModal.module.scss';
export var RefusalModal = function (props) {
    var i18n = props.i18n, reasons = props.reasons, defaultReason = props.defaultReason, isLoading = props.isLoading, onCancel = props.onCancel, onValidate = props.onValidate;
    var _a = useState(''), searchValue = _a[0], setSearchValue = _a[1];
    var _b = useState(defaultReason), currentItem = _b[0], setCurrentItem = _b[1];
    var _c = useState(!valueExist(defaultReason)), isValidateButtonDisabled = _c[0], updateStateValidateButton = _c[1];
    var reasonsFiltered = reasons.filter(function (reason) {
        var _a, _b;
        return ((_a = reason.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue.toLowerCase())) ||
            ((_b = reason.code) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchValue.toLowerCase()));
    });
    var reasonsLabels = reasonsFiltered.map(function (reason) { return reason === null || reason === void 0 ? void 0 : reason.label; }); //) || reason?.code) ||.filter(Boolean) => FRONT-2823
    var modalTitle = getPropsByKeyPath(i18n, 'keyValueMap.caseGlobalView.moActions.showCaseAbortModal.popup.title');
    var modalSubtitle = getPropsByKeyPath(i18n, 'modules.caseAbort.subText');
    var labelCancelButton = getPropsByKeyPath(i18n, 'modules.caseAbort.cancelButtonLabel');
    var labelValidateButton = getPropsByKeyPath(i18n, 'modules.caseAbort.submitButtonLabel');
    var searchPlaceholder = getPropsByKeyPath(i18n, 'modules.caseAbort.searchPlaceholder');
    var noResults = getPropsByKeyPath(i18n, 'modules.caseAbort.noResults');
    var handleSelectCurrentItem = function (team) {
        if (currentItem === team) {
            setCurrentItem(null);
            updateStateValidateButton(true);
        }
        else {
            setCurrentItem(team);
            updateStateValidateButton(false);
        }
    };
    var handleConfirmRefusalAbort = function () {
        var completedReason = reasonsFiltered.find(function (team) { return team.label === currentItem; });
        if (completedReason) {
            onValidate({ reasonCode: completedReason.code });
        }
        else {
            console.error('Error no reasons was founded when confirm refusal / abort');
        }
    };
    return (_jsxs(Modal, __assign({ title: modalTitle, subtitle: modalSubtitle, className: styles.input, onClose: onCancel, color: COLORS.RED['500'] }, { children: [_jsxs("div", __assign({ className: styles.componentsWrapper }, { children: [_jsx(TextInput, { label: searchPlaceholder, value: searchValue, onChange: setSearchValue, rightIcon: E_ICONS.SEARCH }), _jsx("span", { className: styles.separator }), reasonsLabels && (_jsx(SelectSection, { className: styles.caseReassignmentSelectTeam, list: reasonsLabels, currentFocus: currentItem, theme: E_SELECT_SECTION_THEME.RED, onSelectCurrentItem: handleSelectCurrentItem })), reasonsLabels.length === 0 && _jsx("p", __assign({ className: styles.noResultSearchTeams }, { children: noResults }))] })), _jsxs("div", __assign({ className: styles.actionsWrapper }, { children: [_jsx(Button, { type: EButtonType.ABORT, isEdge: true, label: labelCancelButton, onClick: onCancel }), _jsx(Button, { type: EButtonType.ABORT, label: labelValidateButton, onClick: handleConfirmRefusalAbort, disabled: isValidateButtonDisabled, isLoading: isLoading })] }))] })));
};
